<p-dialog id="selectproductcategory"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          [style]="{width: '30vw'}"
          >
  <ng-template pTemplate="content">
    <app-product-global-category-selector [productId]="firstSelectedProduct" (selectedProductCategory)="onSelectedProductCategory($event)" labelKey="Глобальная категория">
    </app-product-global-category-selector>
    <div class="xl:col-4 sm:col-12">
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button label="ОК!" icon="pi pi-check" (click)="onConfirm('ok')"></p-button>
    <p-button label="Отмена" icon="pi pi-times" (click)="display=false"></p-button>
  </ng-template>
</p-dialog>
